import { maxStretchingDTI, minStretchingDTI } from '../constants';
import { AffordamilityState } from '../types';
import { createTargetDti, getAffordabilityRange, getMinAffordability } from './dtiData';

export const sliderGradient = (state: AffordamilityState, monthlyIncome: number) => {
  const range = getAffordabilityRange(state, monthlyIncome);
  const min = getMinAffordability(state, monthlyIncome);
  const stretchingMax = createTargetDti(state, monthlyIncome, maxStretchingDTI);
  const stretchingMin = createTargetDti(state, monthlyIncome, minStretchingDTI);
  const maxStretch = Number.isNaN(stretchingMax)
    ? 0
    : Math.min(1, Math.max(0, (stretchingMax - min) / range));
  const maxAffordable = Number.isNaN(stretchingMin)
    ? 0
    : Math.min(1, Math.max(0, (stretchingMin - min) / range));
  return {
    maxStretch,
    maxAffordable
  };
};
